module.exports = __webpack_public_path__ + "img/ship.0ed0267e.svg";